export enum FeesEnum {
  PERCENT = 1,
  FIXED = 2,
}
